import { Logout } from '../../pages/Settings';
import { useStores } from '../../stores';
import React from 'react';

const LogoutContainer = ({ closeModal }) => {
	const { userStore } = useStores();

	const logout = () => {
		userStore.setLoggedIn(false);
	};

	return <Logout closeModal={closeModal} logout={logout} />;
};

export default LogoutContainer;
